module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "ch00_fm03_title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Helen Keller")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', {
    staticClass: "fontbl"
  }, [_c('em', [_vm._v("Selected Writings")])])]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v("Edited by"), _c('br'), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("KIM E. NIELSEN")])]), _vm._v(" "), _c('p', {
    staticClass: "author1a"
  }, [_vm._v("Consulting Editor: Harvey J. Kaye")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca22feb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_title.vue
// module id = 63
// module chunks = 0